import { SnoozeTab } from './snooze/SnoozeContext';

export enum ContainerBulkAction {
    CANCEL_VISITS = 'CANCEL_VISITS',
    REASSIGN_VISITS = 'REASSIGN_VISITS',
}

// Bulk cancel is offered only in the active view: the snoozed set isn't a
// meaningful subset to bulk-cancel. `snoozeTab` is undefined for non-snoozable
// queues (no tabs), which leaves bulk actions on as before.
export const shouldShowBulkCancel = ({
    bulkCancelEnabled,
    hasVisitCancelPermission,
    bulkActions,
    snoozeTab,
}: {
    bulkCancelEnabled: boolean;
    hasVisitCancelPermission: boolean;
    bulkActions: ContainerBulkAction[];
    snoozeTab: SnoozeTab | undefined;
}): boolean =>
    bulkCancelEnabled &&
    hasVisitCancelPermission &&
    bulkActions.includes(ContainerBulkAction.CANCEL_VISITS) &&
    snoozeTab !== SnoozeTab.SNOOZED;

export const shouldShowBulkReassign = ({
    bulkActions,
    snoozeTab,
}: {
    bulkActions: ContainerBulkAction[];
    snoozeTab: SnoozeTab | undefined;
}): boolean =>
    bulkActions.includes(ContainerBulkAction.REASSIGN_VISITS) && snoozeTab !== SnoozeTab.SNOOZED;
